import { useContext } from 'react';
import { APHChartsDataContext } from '../contexts/APHChartsDataContext';

export const useAPHChartsDataContext = () => {
    return useContext(APHChartsDataContext);
};
